import React, { Component } from 'react';
import { WaitingForEmr, LoadingOverlay } from '@imprivata/nucleus';

/**
 * WaitingForEMR Component
 */
export class WaitingForEmrPage extends Component {
  constructor(props){
    super(props);
    this.state = { showLoading: true, };
  }

  // show loading for 3 seconds
  async componentDidMount() {
    setTimeout( () => {
      this.setState({ showLoading: false, });
      console.log('setting timer');
    }, 3000);
  }

  render() {
    return (
      this.state.showLoading ?
        <LoadingOverlay showOverlay/>
        :
        <div className='content-body'>
          <WaitingForEmr />
        </div>
    );
  }
}

export default WaitingForEmrPage;
